import { render, staticRenderFns } from "./ProductCategoryProviderModal.vue?vue&type=template&id=6268c106&scoped=true&"
import script from "./ProductCategoryProviderModal.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryProviderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6268c106",
  null
  
)

export default component.exports